/**
 * Created by nijin on 8/12/16.
 */
import {Route, PreloadingStrategy} from '@angular/router';
import {Observable} from 'rxjs';
import {of} from 'rxjs/observable/of';
import {Injectable} from '@angular/core';
@Injectable()
export class AppPreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: Function): Observable<any> {
    return route.data && route.data['preload'] ? load() : of(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/preload-strategy.ts